var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.19 12.8V9.38c0-1.98 1.61-3.59 3.59-3.59h13.36c1.98 0 3.59 1.61 3.59 3.59v10.73c0 1.98-1.61 3.59-3.59 3.59h-9.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M38.84 9.55l-9.3 4.99-9.69-5.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.8 34.38l-9.24-7.28M3.84 26.2l8.94 7.1M5.53 27.17l9.34-11.76M11.58 32.18l9.35-11.76M13.59 13.93l8.94 7.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.28,
    cy: 36.99,
    r: 1.69,
    transform: "rotate(-60 30.279 36.996)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.201597612134def382e277c90bf2ce13.svg";
export { ForwardRef as ReactComponent };